import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/offline-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-2dc0a58f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wifi-icon",
  src: _imports_0,
  alt: "wifi icon"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyPageState = _resolveComponent("EmptyPageState")!

  return (_openBlock(), _createBlock(_component_EmptyPageState, {
    colour: "white",
    class: _normalizeClass(['offline-container', _ctx.bordered])
  }, {
    "icon-img": _withCtx(() => [
      _hoisted_1
    ]),
    "header-text": _withCtx(() => [
      _createTextVNode("You're Currently Offline")
    ]),
    "body-text": _withCtx(() => [
      _createTextVNode(" You can access this when you're back online. ")
    ]),
    _: 1
  }, 8, ["class"]))
}